export const CLIENT_APP_STORE_URLS = {
  android:
    "https://play.google.com/store/apps/details?id=br.com.ercard.appwayup.cliente",
  ios: "https://apps.apple.com/br/app/app-wayup/id1438671193"
} as const;

export const CLIENT_APP_STORE_TABS = [
  { label: "Android" },
  { label: "iOS" }
];
